import type { Customer } from "~/lib/api/types/customers";
import type { VectorizeTaskMeta } from "~/lib/api/types/vectorizeTasks";

/** What tells a task's customer apart in the queue. */
export type CustomerTag = {
    /** The customer's country, as the API gives it, where it does. */
    country?: string;
    /** The customer number: the external ID, else the internal one. */
    number: string;
};

/**
 * The customer number the queue shows: the customer's external ID — the
 * number the merchant knows the customer by, for Strauss company and
 * customer number together — else the internal ID.
 */
export function customerNumberOf(
    customer: Pick<Customer, "external_identifier" | "id">,
): string {
    const external = customer.external_identifier?.trim();

    if (external) return external;

    return String(customer.id);
}

/**
 * The customer a task was queued for, as the queue tells it apart: its
 * number and, where known, its country; nothing for a task without one —
 * from the vectorize page, or queued before tasks recorded it.
 */
export function customerTagOf(
    meta: Partial<VectorizeTaskMeta>,
): CustomerTag | undefined {
    const number = meta.customerNumber?.trim();

    if (!number) return;

    const country = meta.country?.trim().toUpperCase();

    return country ? { country, number } : { number };
}
